import { render, staticRenderFns } from "./GoogleSpreadsheetFiles.vue?vue&type=template&id=6370eaf4"
import script from "./GoogleSpreadsheetFiles.vue?vue&type=script&lang=ts"
export * from "./GoogleSpreadsheetFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports